import React from "react";
import "./_about.scss";
import DashboardSideBar from "./DashboardSideBar";

const AboutUs = () => {
  return (
    <DashboardSideBar>
      <div className="w-100">
        <div className="d-flex">
          <div className="about w-100">
            <div className="main">
              <div className="text-center mt-5 mb-3">
                <h1>About Us</h1>
                <p className="opacity-50 mt-2">Who we are and what we do</p>
              </div>
              <div className="about-content">
                <p>
                At <strong>NexGen Inspector Assistant</strong>, we are dedicated to revolutionizing the home inspection
process by leveraging advanced technology to simplify, streamline, and enhance reporting for
professionals in the field. Our app was designed with home inspectors in mind, providing an
intuitive tool to turn inspection notes into polished, professional narratives with just a few taps.

                </p>
                <p className="mt-4">
                We understand the challenges home inspectors face tight schedules, detailed observations, and
the need for precise communication with clients. That's why we created NexGen Inspector
Assistant: a cutting edge solution to save time, ensure accuracy, and deliver professional grade
reports every time.

                </p>
                <p className="mt-4">Our mission is simple:</p>
                <p><strong>Empower home inspectors with smarter tools to improve productivity and elevate industry
                standards.</strong></p>
                <h3>What We Stand For:
                </h3>
                <ul style={{ marginLeft: "20px" }}>
                  <li><p><strong>Innovation:</strong> We’re committed to staying ahead of the curve, utilizing the latest
                  technology to provide features that matter.</p>
</li>
                  <li><p><strong>Efficiency:</strong> Our app is designed to make your workflow faster and easier without
                  compromising on quality.</p></li>
                  <li><p><strong>Professionalism:</strong> We ensure that every report generated reflects the professionalism that
                  home inspectors and their clients deserve.</p></li>
                  <li><p><strong>User-Centered Design:</strong> Your feedback is at the heart of what we do. We listen, adapt,
                  and improve continuously to meet your needs</p>.</li>
                </ul>
                <p className="mt-4">Whether you're an independent inspector or part of a larger team, NexGen Inspector Assistant is
here to help you work smarter, not harder. Join us in transforming the home inspection industry
and discover how our app can take your inspections to the next level.</p>
<p className="mt-4">Let’s build the future of home inspections together!</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardSideBar>
  );
};

export default AboutUs;
